import { useState, useEffect, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import AuthContext from '../context/AuthContext';
import EventCard from '../components/EventCard';
import config from '../config';

const Events = () => {
    const { user } = useContext(AuthContext);
    const navigate = useNavigate();
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedCategory, setSelectedCategory] = useState('all');

    const categories = [
        { value: 'all', label: 'All Events' },
        { value: 'kids', label: 'Kids Events' },
        { value: 'adults', label: 'Adult Events' }
    ];

    useEffect(() => {
        fetchEvents();
    }, [selectedCategory]);

    const fetchEvents = async () => {
        try {
            setLoading(true);
            const url = selectedCategory === 'all'
                ? `${config.API_URL}/events`
                : `${config.API_URL}/events?category=${selectedCategory}`;

            const res = await axios.get(url);
            setEvents(res.data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching events:', error);
            setLoading(false);
        }
    };

    const handleDelete = async (eventId) => {
        if (!window.confirm('Are you sure you want to delete this event?')) {
            return;
        }

        try {
            const token = localStorage.getItem('token');
            await axios.delete(`${config.API_URL}/events/${eventId}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setEvents(events.filter(event => event.id !== eventId));
            alert('Event deleted successfully!');
        } catch (error) {
            console.error('Error deleting event:', error);
            alert('Failed to delete event. Please try again.');
        }
    };

    const handleEdit = (eventId) => {
        navigate(`/edit-event/${eventId}`);
    };

    if (loading) {
        return <div className="container">Loading events...</div>;
    }

    return (
        <div className="events-page" style={{ backgroundColor: '#fbf5ec', minHeight: '100vh', paddingTop: '2rem', paddingBottom: '4rem' }}>
            <div className="container">
                {user && (
                    <Link to="/add-event" className="floating-action-btn">
                        + Add Event
                    </Link>
                )}

                <div className="shop-header">
                    <h1>Chess Events</h1>
                    <p>Join exciting chess tournaments and events for all ages</p>
                </div>

                <div className="shop-filters">
                    <div className="filter-buttons">
                        {categories.map(cat => (
                            <button
                                key={cat.value}
                                className={`filter-btn ${selectedCategory === cat.value ? 'active' : ''}`}
                                onClick={() => setSelectedCategory(cat.value)}
                            >
                                {cat.label}
                            </button>
                        ))}
                    </div>
                </div>

                {events.length === 0 ? (
                    <div className="no-products">
                        <p>No events found in this category.</p>
                    </div>
                ) : (
                    <div className="product-grid">
                        {events.map(event => (
                            <EventCard
                                key={event.id}
                                event={event}
                                user={user}
                                onDelete={handleDelete}
                                onEdit={handleEdit}
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Events;
